module.exports = __webpack_public_path__ + "static/media/sec3Video.4029aff7.mp4";